export const version = "1.7.17-daily-20260824-0";
export const channel = "daily";
export const gitcommit = "a1ae826b3";
